import React, { useState, useEffect } from 'react'
import * as Colors from './colors'
import * as Typography from './typography'
import { Left, Right } from 'native-base'
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native'

export const PrimaryButton = ({ text, onPress }) => {
    return (
        <TouchableOpacity onPress={onPress}>
            <View style={Typography.ButtonStyling.PrimaryButtonContainerStyle}>
                <Text style={Typography.ButtonStyling.PrimaryButtonText}> {text} </Text>
            </View>
        </TouchableOpacity>
    )
  }

  export const DarkButton = ({ text, onPress }) => {
    return (
        <TouchableOpacity onPress={onPress}>
            <View style={Typography.ButtonStyling.DarkButtonContainerStyle}>
                <Text style={Typography.ButtonStyling.DarkButtonText}> {text} </Text>
            </View>
        </TouchableOpacity>
    )
  }